<template>  
  <div class="salesmanfenxiang">
    <XR-head titleText="分享设置"></XR-head>
    
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33">
      <div class="remark">  
        <mu-text-field  label="微商城分享语"  hintText="快来我的商城逛逛" help-text="*在您将商城分享给好友时，分享语就会显示在推广页面中哦" v-model="editInfo.wscfxy" multiLine :rows="3" :rowsMax="6" fullWidth :maxLength="100" />
      </div>
      </mu-col>
    </mu-row>
    <mu-row class="gutter" >
      <mu-col width="100" tablet="50" desktop="33" class="button-row">
        <mu-raised-button  label="保存设置" class="submit" primary fullWidth @click="submit" />
      </mu-col>
    </mu-row>
    
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editInfo:{
        wscfxy : ''
      }
    }
  },
  mounted(){
    this.getSetting()
  },
  methods: {     
    getSetting: function(){
      var ths = this;  
      
      ths.$post(
        "/Salesman/SalesmanServer/GetShopSetting"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.editInfo.wscfxy =  res.Data.Memo
        }
      });
    },
    submit: function(){
      var ths = this;  
      
      ths.$post(
        "/Salesman/SalesmanServer/ShopSettingShareRemark",
        JSON.stringify(this.editInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>

<style>
body .salesmanfenxiang {
  background: white;
}
.salesmanfenxiang .remark{
  background: white;
  margin-top: 10px;
  padding: 10px;
}
.salesmanfenxiang .button-row{  
  padding: 40px 20px 0 20px;
}
.salesmanfenxiang .remark{
  padding: 0px 3%;
}
.salesmanfenxiang .gutter{
  padding: 40px 5% 30px;
        }
.salesmanfenxiang .submit{
  height: 50px;
}
</style>




// WEBPACK FOOTER //
// src/pages/salesman/fenxiang.vue